import { render, staticRenderFns } from "./BrowserWarning.vue?vue&type=template&id=34a97543&scoped=true"
import script from "./BrowserWarning.vue?vue&type=script&lang=js"
export * from "./BrowserWarning.vue?vue&type=script&lang=js"
import style0 from "./BrowserWarning.vue?vue&type=style&index=0&id=34a97543&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a97543",
  null
  
)

export default component.exports